import React from "react";
import { motion } from "framer-motion";
import { TIMELINE } from "../../data/hseData";

export const Timeline = () => {
  return (
    <section id="anos" data-testid="section-anos" className="relative py-24 sm:py-32 bg-[#0B1B2D] overflow-hidden">
      {/* Decorative big number */}
      <div className="absolute -top-10 right-0 pointer-events-none select-none">
        <div
          className="font-condensed font-bold tracking-tight text-[18rem] sm:text-[28rem] leading-none"
          style={{ color: "rgba(217,35,35,0.05)" }}
        >
          20
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative">
        <div className="inline-flex items-center gap-3 mb-6">
          <span className="w-8 h-px bg-[#2FA36B]" />
          <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">
            20 Anos de História
          </span>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 items-start mb-16">
          <h2 className="lg:col-span-7 font-condensed font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight">
            20 anos de experiência em
            <span className="text-[#2FA36B]"> campo, conhecimento aplicado</span> e compromisso com a vida.
          </h2>
          <div className="lg:col-span-5 text-white/70 font-body text-base sm:text-lg leading-relaxed">
            <p>
              Em 2026, a HSE celebra 20 anos de atuação. Uma história construída com trabalho técnico, confiança, disciplina operacional e compromisso com a preservação da vida, do meio ambiente e da continuidade dos negócios de nossos clientes.
            </p>
          </div>
        </div>

        {/* Timeline grid */}
        <div className="relative grid md:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {TIMELINE.map((t, i) => (
            <motion.div
              key={t.year}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`timeline-${t.year}`}
              className="bg-[#0F0F0F] hover:bg-[#173250] transition-colors p-7 sm:p-9 relative group"
            >
              <div className="flex items-center gap-3 mb-5">
                <span className="w-3 h-3 bg-[#2FA36B] block" />
                <span className="font-condensed uppercase text-[10px] tracking-[0.3em] text-white/40 font-bold">
                  Marco {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="font-condensed font-bold text-4xl sm:text-5xl text-white tracking-tight leading-none mb-4 group-hover:text-[#2FA36B] transition-colors">
                {t.year}
              </div>
              <h3 className="font-condensed font-bold uppercase text-lg sm:text-xl text-white tracking-tight leading-tight mb-3">
                {t.title}
              </h3>
              <p className="font-body text-sm text-white/60 leading-relaxed">
                {t.text}
              </p>
              <div className="mt-6 h-px w-12 bg-[#2FA36B] group-hover:w-full transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Timeline;
